import { RootState } from "redux/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TeamMember = {
  fullName: string;
  email: string;
  mobileNumber: string;
  role: string;
};

export interface ISignup {
  step: "signup" | "otp" | "details" | "team" | "onedrive" | "googledrive";
  token: string;
  fullName: string;
  email: string;
  password: string;
  mobileNumber: any;
  firmType: string;
  firmName: string;
  firmStatus: string;
  gstNumber: string;
  state: string;
  city: string;
  pincode: string;
  teamMembers: Array<TeamMember>;
  dialCode: string;
  countryCode: string;
  channelPartnerId: number | null;
  couponCode: string;
  isCouponVerified: boolean;
}

const initialState: ISignup = {
  step: "signup",
  token: "",
  fullName: "",
  email: "",
  password: "",
  mobileNumber: "",
  firmType: "",
  firmName: "",
  firmStatus: "",
  gstNumber: "",
  state: "",
  city: "",
  pincode: "",
  teamMembers: [],
  countryCode: "IN",
  dialCode: "91",
  channelPartnerId: null,
  couponCode: "",
  isCouponVerified: false,
};

export const signupSlice = createSlice({
  name: "signup",
  initialState,
  reducers: {
    handleStep(state, action: PayloadAction<"signup" | "otp" | "details" | "onedrive">) {
      state.step = action.payload;
    },
    handleFieldChange(state, action: PayloadAction<{ name: string; value: string }>) {
      state[action.payload.name] = action.payload.value;
    },
    handleToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
    handleTeamMember(state, action: PayloadAction<TeamMember>) {
      state.teamMembers.push(action.payload);
    },
    setCouponDetails(
      state,
      action: PayloadAction<{ couponCode: string; channelPartnerId: number | null }>
    ) {
      state.couponCode = action.payload.couponCode;
      state.channelPartnerId = action.payload.channelPartnerId;
      state.isCouponVerified = false; // reset on change
    },
    setCouponVerified(state, action: PayloadAction<boolean>) {
      state.isCouponVerified = action.payload;
    },
  },
});

export const selectSignup = (state: RootState) => state.signup;

export const { handleToken, handleStep, handleFieldChange, handleTeamMember, setCouponDetails, setCouponVerified } = signupSlice.actions;

export default signupSlice.reducer;
